import React from 'react';

const Tims4GoodContext = React.createContext({
  lang: 'en',
  sendMessage: () => {},
  youtubeConsent: false,
  setYoutubeConsent: () => {},
});

export default Tims4GoodContext;
